/*
  Adresse de l'API, calculée à l'exécution.

  L'application peut être installée à la racine d'un domaine
  (https://kwata.fr/) ou dans un sous-dossier (https://amento.fr/kwata/public/).
  Une adresse écrite en dur comme « /api/sync » ne marche que dans le premier
  cas : dans le second, le navigateur irait chercher https://amento.fr/api/sync
  et recevrait une erreur.

  `document.baseURI` donne l'adresse du document courant. Le routage se faisant
  sur le fragment (#/patrouille), le chemin ne change jamais après le
  chargement : cette base reste valable pendant toute la session.
*/

export function urlApi(chemin: string): string {
  const relatif = chemin.replace(/^\/+/, '')
  return new URL(`api/${relatif}`, baseApplication()).toString()
}

/**
 * Dossier d'installation de l'application, terminé par « / ».
 *
 * Exporté pour les tests : c'est le calcul le plus facile à casser sans s'en
 * apercevoir, parce qu'il est correct en développement (racine du domaine)
 * quoi qu'on écrive.
 */
export function baseApplication(base: string = document.baseURI): string {
  // Retire le fragment, la requête, puis le nom de fichier éventuel.
  const sansFragment = base.split('#')[0]?.split('?')[0] ?? base
  return sansFragment.replace(/[^/]*$/, '')
}
